import React, { Fragment, useState, useMemo } from "react";
import { closeModal } from "../../store/modal/modalReducer";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { Dialog, Transition } from "@headlessui/react";
import { Formik, Form, Field } from "formik";
import ErrorBoundary from "../../containers/ErrorBoundary";
import NotificationToast from "../Helpers/NotificationToast";
import SubmitButton from "../Forms/SubmitButton";
import { getBooking } from "../../store/booking/bookingActions";

export default function ModalArchiveTag(props) {
  const dispatch = useDispatch();
  const [open] = useState(true);
  const { tags } = useSelector((state) => state.tags);
  const { current_staff } = useSelector((state) => state.auth);

  const archiveTags = useMemo(() => {
    const list = Array.isArray(tags) ? tags : [];
    return list
      .filter((tag) => tag.parent_folder === "Archived")
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  }, [tags]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_API_URL}archive/${props.id}`,
        data: {
          archive: true,
          type: props.type,
          tag_id: values.tag && values.tag !== "0" ? values.tag : props.tag_id,
          archive_tag_id: values.tag && values.tag !== "0" ? values.tag : null,
          current_staff_id: current_staff.id,
        },
      });
      toast(
        <NotificationToast
          title="Archived Succesfully"
          message="The booking has been updated succesfully."
        />,
      );
      dispatch(getBooking());
      dispatch(closeModal());
    } catch (error) {
      toast(
        <NotificationToast
          title="Something went wrong"
          message={error?.message || "Failed to archive"}
          type="error"
        />,
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-50 inset-0 overflow-y-auto"
        open={open}
        onClose={() => dispatch(closeModal())}
      >
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <ErrorBoundary>
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-auto shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 relative">
                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4 z-50">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0"
                    onClick={() => dispatch(closeModal())}
                  >
                    <span className="sr-only">Close</span>
                    <FontAwesomeIcon
                      className="h-6 w-6"
                      aria-hidden="true"
                      icon={faTimes}
                    />
                  </button>
                </div>

                <div className="pr-8 w-full">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Formik
                      initialValues={{ tag: "0" }}
                      onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, isValid }) => (
                        <Form className="space-y-6 m-4 w-full">
                          <h2 className="text-lg font-medium text-gray-900">
                            Archive Booking
                          </h2>
                          <p className="text-sm text-gray-500">
                            Choose a tag for this archived booking.
                          </p>

                          <div>
                            <h3 className="text-sm font-medium mb-2">Tag:</h3>
                            <Field
                              as="select"
                              name="tag"
                              className="capitalize cursor-pointer relative p-2 mx-2 bg-light_background rounded-md transition duration-150 ease-in-ease-out hover:-translate-y-0.5"
                            >
                              <option value="0">No Tag</option>
                              {archiveTags.map((tag) => (
                                <option key={tag.id} value={tag.id}>
                                  {tag.name}
                                </option>
                              ))}
                            </Field>
                            {process.env.REACT_APP_COLOUR === "UC" && (
                              <p className="text-xs text-gray-500 mt-2 mx-2">
                                Note: choosing <span className="font-medium">No Tag</span> will auto-assign a tag based on the student's year (from ID number).
                              </p>
                            )}
                          </div>

                          <div className="mt-6">
                            <SubmitButton
                              name="Archive"
                              disabled={!isValid || isSubmitting}
                              isSubmitting={isSubmitting}
                              text="Archive"
                            />
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </ErrorBoundary>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
